module.exports = __webpack_public_path__ + "assets/img/4dff-pn.svg";